function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67805 8.06166C6.30193 6.1565 8.71841 4.9005 9.9275 4.29366C13.3797 2.56102 14.097 2.26004 14.5646 2.25011C14.6674 2.24792 14.8974 2.27867 15.0463 2.4245C15.1721 2.54764 15.2067 2.71397 15.2232 2.83072C15.2398 2.94747 15.2604 3.21342 15.244 3.42122C15.0569 5.79307 14.2474 11.5489 13.8356 14.2055C13.6614 15.3295 13.3183 15.7064 12.9861 15.7433C12.2642 15.8235 11.716 15.1676 11.0169 14.6146C9.92277 13.7492 9.30468 13.2105 8.24268 12.366C7.01536 11.3901 7.81098 10.8537 8.51043 9.97706C8.69348 9.74764 11.8741 6.25669 11.9357 5.94001C11.9434 5.9004 11.9505 5.75277 11.8779 5.67481C11.8052 5.59686 11.6979 5.62351 11.6205 5.64472C11.5107 5.67477 9.76293 7.06876 6.37703 9.82669C5.88092 10.2378 5.43156 10.438 5.02895 10.4276C4.5851 10.416 3.73131 10.1247 3.09661 9.87577C2.31812 9.57042 1.69939 9.40897 1.75327 8.89039C1.78133 8.62028 2.08959 8.34403 2.67805 8.06166Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram03);
export default __webpack_public_path__ + "static/media/telegram-03.6302b64ebb173fd1227b7247e0332c38.svg";
export { ForwardRef as ReactComponent };